import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, Card, Row, Col, Container } from "react-bootstrap";
import { FiArrowLeft, FiPlus, FiTrash2 } from "react-icons/fi";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { toast } from 'react-toastify';
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  API_CONTACT_GROUP_MEMBERS_CREATE,
  API_CONTACT_GROUP_MEMBERS_LIST,
} from "../../../service/url";

const CreateContact = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [contact, setContact] = useState({
    firstName: "",
    lastName: "",
    street: "",
    city: "",
    state: "",
    country: "",
    primaryNumber: "",
    isPrimaryNumber: false,
    alternateNumbers: [{ number: "", isPrimary: false }],
    company: "",
    isPrimary: true,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "primaryNumber") {
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
      setContact({ ...contact, [name]: cleanedValue });
    } else {
      setContact({ ...contact, [name]: value });
    }
  };

  const handlePrimaryNumberCheck = (e) => {
    const { checked } = e.target;
    setContact((prev) => ({
      ...prev,
      isPrimaryNumber: checked,
      alternateNumbers: prev.alternateNumbers.map((num) => ({
        ...num,
        isPrimary: false,
      })),
    }));
  };

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  const handleAlternateNumberChange = (index, field, value) => {
    const newAlt = [...contact.alternateNumbers];

    if (field === "isPrimary") {
      newAlt.forEach((num, i) => {
        num.isPrimary = i === index ? !newAlt[index].isPrimary : false;
      });

      setContact((prev) => ({
        ...prev,
        isPrimaryNumber: false,
        alternateNumbers: newAlt,
      }));
    } else {
      newAlt[index][field] = value;
      setContact((prev) => ({
        ...prev,
        alternateNumbers: newAlt,
      }));
    }
  };

  const [buttonDisable, setButtonDisable] = useState(false);

  const addAlternateNumber = () => {
    setContact((prev) => ({
      ...prev,
      alternateNumbers: [
        ...prev.alternateNumbers,
        { number: "", isPrimary: false },
      ],
    }));
  };

  function onListSuccess(resp) {
    setContact(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      firstName,
      lastName,
      primaryNumber,
      street,
      city,
      state,
      country,
      company,
      alternateNumbers = [],
    } = contact;

    const primaryAlternate = alternateNumbers.find((num) => num.isPrimary);
    const finalPrimaryNumber = primaryAlternate
      ? primaryAlternate.number
      : primaryNumber;

    const allNumbers = [
      ...alternateNumbers
        .filter((num) => !num.isPrimary)
        .map((num) => num.number),
      ...(primaryAlternate ? [primaryNumber] : []),
    ].filter((num) => num && num.trim() !== "" && num !== finalPrimaryNumber);

    const [alt1_number, alt2_number] = allNumbers.slice(0, 2);

    if (
      !firstName.trim() ||
      !lastName.trim() ||
      !finalPrimaryNumber.trim() ||
      !street.trim() ||
      !city.trim() ||
      !state.trim() ||
      !country.trim() ||
      !company.trim()
    ) {
      // setToastProps({
      //   message: "Please fill in all required fields",
      //   type: "danger",
      // });
          toast.error("Please fill in all required fields");
      return;
    }

    const payload = {
      first_name: firstName,
      last_name: lastName,
      street: street,
      city: city,
      state: state,
      country: country,
      company: company,
      contact_group_id: id,
      primary_number: finalPrimaryNumber,
      alt1_number: alt1_number || null,
      alt2_number: alt2_number || null,
    };

    const hasPrimaryAlternate = alternateNumbers.some((num) => num.isPrimary);
    if (!contact.isPrimaryNumber && !hasPrimaryAlternate) {
      // setToastProps({
      //   message: "Please mark at least one phone number as primary",
      //   type: "danger",
      // });
          toast.error("Please mark at least one phone number as primary");
      return;
    }

    postApiCall(API_CONTACT_GROUP_MEMBERS_CREATE, payload)
      .then((resp) => {
        onCreateSuccess(resp);
        setButtonDisable(false);
      })
      .catch((err) => {
        onCreateError(err);
        setButtonDisable(false);
      });
  };

  function onCreateSuccess(resp) {
    // setToastProps({
    //   message: "Contact Member created successfully",
    //   type: "success",
    // });
        toast.success("Contact Member created successfully");

    getApiCall(API_CONTACT_GROUP_MEMBERS_LIST, {})
      .then(onListSuccess)
      .catch(onError);

    setTimeout(() => {
      navigate(`/contact-group/${id}`);
    }, 1000);
  }

  function onCreateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
          toast.error(JSON.stringify(err));
    }
  }

  return (
    <Container fluid className="py-4">
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4">
          <div className="d-flex align-items-center mb-4">
            <Button
              variant="link"
              className="p-0 me-3"
              onClick={() => navigate(-1)}
            >
              <FiArrowLeft size={20} />
            </Button>
            <h4 className="mb-0">Create Contact</h4>
          </div>

          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group controlId="firstName">
                  <Form.Label>
                    First name<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={contact.firstName}
                    onChange={handleInputChange}
                    placeholder="Ex. John"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="lastName">
                  <Form.Label>
                    Last name<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={contact.lastName}
                    onChange={handleInputChange}
                    placeholder="Ex. Smith"
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group controlId="street">
                  <Form.Label>
                    Street<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="street"
                    value={contact.street}
                    onChange={handleInputChange}
                    placeholder="Ex. Ninth Street"
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="city">
                  <Form.Label>
                    City<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={contact.city}
                    onChange={handleInputChange}
                    placeholder="Ex. New York"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="state">
                  <Form.Label>
                    State/Province <span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={contact.state}
                    onChange={handleInputChange}
                    placeholder="Ex. NY"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="country">
                  <Form.Label>
                    Country<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="country"
                    value={contact.country}
                    onChange={handleInputChange}
                    placeholder="Ex. USA"
                  />
                </Form.Group>
              </Col>

              <Col md={9}>
                <Form.Group controlId="primaryNumber">
                  <Form.Label>
                    Primary Phone Number<span style={{ color: "red", margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    name="primaryNumber"
                    value={contact.primaryNumber}
                    onChange={handleInputChange}
                    placeholder="Ex. 0123456789"
                    required
                    maxLength={10}
                    pattern="[0-9]{10}"
                    onInput={(e) => {
                      // Remove any non-digit characters
                      e.target.value = e.target.value.replace(/\D/g, "");
                      // Ensure maximum length of 10 digits
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                  />
                  <Form.Text className="text-muted">
                    Please enter exactly 10 digits (numbers only)
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-end">
                <Form.Check
                  type="checkbox"
                  id="isPrimaryNumber"
                  label="Set as primary"
                  name="isPrimaryNumber"
                  checked={contact.isPrimaryNumber}
                  onChange={handlePrimaryNumberCheck}
                />
              </Col>
              {contact?.alternateNumbers?.map((alt, index) => (
                <React.Fragment key={index}>
                  <Col md={9}>
                    <Form.Group controlId={`alternateNumber-${index}`}>
                      <Form.Label>
                        {index === 0
                          ? "Alternate Phone Number"
                          : `Alternate Phone Number ${index + 1}`}
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        value={alt.number}
                        onChange={(e) => {
                          const cleanedValue = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10);
                          handleAlternateNumberChange(
                            index,
                            "number",
                            cleanedValue
                          );
                        }}
                        placeholder="Ex. 0123456789"
                        maxLength={10}
                        pattern="[0-9]{10}"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "");
                          if (e.target.value.length > 10) {
                            e.target.value = e.target.value.slice(0, 10);
                          }
                        }}
                      />
                      <Form.Text className="text-muted">
                        {alt.number.length === 10
                          ? "✓ Valid 10-digit number"
                          : "Enter 10 digits (numbers only)"}
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={3} className="d-flex align-items-center gap-2 pt-4">
                    <Form.Check
                      type="checkbox"
                      label="Set as primary"
                      checked={alt.isPrimary}
                      onChange={() =>
                        handleAlternateNumberChange(index, "isPrimary")
                      }
                    />
                  </Col>
                </React.Fragment>
              ))}

              <Col md={12}>
                {contact?.alternateNumbers?.length < 2 && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={addAlternateNumber}
                    className="mb-3"
                  >
                    <FiPlus className="me-1" />
                    Add phone number
                  </Button>
                )}
              </Col>

              <Col md={12}>
                <Form.Group controlId="company">
                  <Form.Label>
                    Company<span style={{ color: "red",margin: "0 4px" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="company"
                    value={contact.company}
                    onChange={handleInputChange}
                    placeholder="Ex. Voxtech Co"
                  />
                </Form.Group>
              </Col>

              <Col md={12} className="mt-4">
                <div className="d-flex justify-content-end gap-3">
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Create Contact
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </Container>
  );
};

export default CreateContact;
